// extracted by mini-css-extract-plugin
export default {"BannerArea":"Banner_BannerArea__-1dHV","Container":"Banner_Container__fhaeI","Titulo":"Banner_Titulo__V3QGI"};